import { useState } from "react";
import { api, ApiHatasi, sayi, tarih, vekalet } from "../api";
import { Bildirim, Durum, HataKutusu, Kart, Olcu, Rozet, Tablo, useCek } from "../ui";
import { AbonelikKarti } from "./Fatura";

export function MusteriDetay({ id, git }: { id: string; git: (yol: string) => void }) {
  const m = useCek(() => api.musteri(id), [id]);
  const limit = useCek(() => api.musteriLimit(id), [id]);
  const [islem, setIslem] = useState<ApiHatasi | null>(null);
  const [bilgi, setBilgi] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  async function durumDegistir(askiya: boolean) {
    const sebep = askiya ? window.prompt("Askıya alma sebebi:", "Ödeme alınmadı") : null;
    if (askiya && sebep === null) return;
    setIslem(null);
    setBilgi(null);
    setBekliyor(true);
    try {
      const y = askiya ? await api.musteriAskiyaAl(id, sebep ?? "") : await api.musteriAktifEt(id);
      setBilgi(
        `${y.etkilenen.length} kutu ${askiya ? "kilitlendi" : "açıldı"}. ` +
          (askiya ? "Gelen posta kabul edilmeye devam eder." : ""),
      );
      m.yenile();
      limit.yenile();
    } catch (h) {
      setIslem(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  async function paketDegistir(paket: string) {
    setIslem(null);
    setBekliyor(true);
    try {
      await api.musteriGuncelle(id, { paket });
      setBilgi("Paket güncellendi. Limitler yeniden değerlendirildi.");
      m.yenile();
      limit.yenile();
    } catch (h) {
      setIslem(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Durum cekim={m}>
      {(d) => (
        <>
          <div className="baslik">
            <div>
              <h1>{d.veri.ad}</h1>
              <p>
                <span className="tek">{d.veri.id}</span> · {d.veri.yetkili_eposta ?? "yetkili yok"}
                {d.veri.telefon ? " · " + d.veri.telefon : ""}
              </p>
            </div>
            <div className="eylemler">
              <button className="dugme" onClick={() => git("/musteriler")}>
                ← liste
              </button>
              {/*
                Musterinin gordugunu gormenin tek yolu onun gozunden bakmak.
                Ekran goruntusu istemek ya da veritabanina bakmak "neden bu
                dugme bende yok" sorusunu cevaplamaz: sebep rol, paket, kota
                ya da kiraci suzgeci olabilir.
              */}
              <button
                className="dugme"
                onClick={() => {
                  vekalet.basla(d.veri.id, d.veri.ad);
                  // Tam yeniden yukleme: butun cekimler yeni yetkiyle bastan yapilsin
                  window.location.hash = "/";
                  window.location.reload();
                }}
              >
                Müşteri gözüyle gör
              </button>
              {d.veri.durum === "aktif" ? (
                <button className="dugme tehlike" disabled={bekliyor} onClick={() => durumDegistir(true)}>
                  Askıya al
                </button>
              ) : (
                <button className="dugme ana" disabled={bekliyor} onClick={() => durumDegistir(false)}>
                  Aktif et
                </button>
              )}
            </div>
          </div>

          {islem && <HataKutusu hata={islem} />}
          {bilgi && <Bildirim tur="iyi">{bilgi}</Bildirim>}
          {d.veri.durum !== "aktif" && (
            <Bildirim tur="kotu">
              Bu müşteri <strong>askıda</strong>. Kutulara giriş ve gönderim kapalı; gelen posta kabul
              edilmeye devam ediyor, veri kaybı yok.
            </Bildirim>
          )}

          <Durum cekim={limit}>
            {(l) => (
              <>
                <div className="izgara d4" style={{ marginBottom: 18 }}>
                  <Olcu
                    ad="Posta kutusu"
                    deger={sayi(l.veri.kutu.kullanilan)}
                    birim={"/ " + (l.veri.kutu.limit ?? "∞")}
                    oran={l.veri.kutu.limit ? l.veri.kutu.kullanilan / l.veri.kutu.limit : null}
                  />
                  <Olcu
                    ad="Disk"
                    deger={l.veri.disk.kullanilanMb.toFixed(1)}
                    birim={"/ " + (l.veri.disk.limitMb ?? "∞") + " MB"}
                    oran={l.veri.disk.limitMb ? l.veri.disk.kullanilanMb / l.veri.disk.limitMb : null}
                  />
                  <Olcu
                    ad="Bugünkü gönderim"
                    deger={sayi(l.veri.gonderim.kullanilan)}
                    birim={"/ " + sayi(l.veri.gonderim.limit) + " alıcı"}
                    oran={l.veri.gonderim.kullanilan / l.veri.gonderim.limit}
                    not={
                      l.veri.gonderim.kilitli ? (
                        <Rozet tur="kotu">gönderim kilitli</Rozet>
                      ) : (
                        `${sayi(l.veri.gonderim.kalan)} alıcı hakkı kaldı`
                      )
                    }
                  />
                  <Olcu ad="Alan adı" deger={d.alanlar.length} birim={"/ " + (l.veri.paket.alanAdi ?? "∞")} />
                </div>

                <div className="izgara d2">
                  <AbonelikKarti kiraciId={id} />

                  <BilgiDuzenle
                    m={d.veri}
                    kaydedildi={() => {
                      setBilgi("Bilgiler güncellendi.");
                      m.yenile();
                    }}
                    hata={setIslem}
                  />

                  <Kart baslik="Paket">
                    <div className="ic">
                      <label className="alan">
                        <span>Paket değiştir</span>
                        <select
                          value={d.veri.paket}
                          disabled={bekliyor}
                          onChange={(e) => paketDegistir(e.target.value)}
                        >
                          <option value="baslangic">baslangic</option>
                          <option value="kurumsal">kurumsal</option>
                          <option value="sinirsiz">sinirsiz</option>
                        </select>
                        <small>
                          Paket büyütüldüğünde, günlük hakkı dolduğu için kilitlenmiş kutular hemen
                          yeniden açılır.
                        </small>
                      </label>
                      <Tablo basliklar={["Sınır", "#Değer"]}>
                        <tr>
                          <td>Kutu sayısı</td>
                          <td className="sayi">{l.veri.paket.kutu ?? "sınırsız"}</td>
                        </tr>
                        <tr>
                          <td>Disk</td>
                          <td className="sayi">{l.veri.paket.diskMb ? l.veri.paket.diskMb + " MB" : "sınırsız"}</td>
                        </tr>
                        <tr>
                          <td>Günlük alıcı</td>
                          <td className="sayi">{sayi(l.veri.paket.gunlukAlici)}</td>
                        </tr>
                        <tr>
                          <td>Alan adı</td>
                          <td className="sayi">{l.veri.paket.alanAdi ?? "sınırsız"}</td>
                        </tr>
                      </Tablo>
                    </div>
                  </Kart>

                  <Kart baslik={`Alan adları (${d.alanlar.length})`}>
                    {d.alanlar.length === 0 ? (
                      <div className="bos">Bu müşteriye henüz alan adı tanımlanmadı</div>
                    ) : (
                      <Tablo basliklar={["Alan adı"]}>
                        {d.alanlar.map((a) => (
                          <tr key={a}>
                            <td className="tek">{a}</td>
                          </tr>
                        ))}
                      </Tablo>
                    )}
                  </Kart>
                </div>

                {l.veri.kilitliKutular.length > 0 && (
                  <div style={{ marginTop: 18 }}>
                    <Kart baslik={`Kilitli kutular (${l.veri.kilitliKutular.length})`}>
                      <Tablo basliklar={["Adres"]}>
                        {l.veri.kilitliKutular.map((e) => (
                          <tr key={e}>
                            <td className="tek">{e}</td>
                          </tr>
                        ))}
                      </Tablo>
                    </Kart>
                  </div>
                )}

                <div style={{ marginTop: 18 }}>
                  <Kart baslik="Son 30 gün">
                    {l.veri.gecmis.length === 0 ? (
                      <div className="bos">Henüz veri toplanmadı</div>
                    ) : (
                      <Tablo basliklar={["Tarih", "#Kutu", "#Disk", "#Giden", "#Gelen"]}>
                        {[...l.veri.gecmis].reverse().map((s) => (
                          <tr key={s.tarih}>
                            <td>{s.tarih}</td>
                            <td className="sayi">{s.kutu_sayisi}</td>
                            <td className="sayi">{(s.disk_bayt / 1048576).toFixed(1)} MB</td>
                            <td className="sayi">{sayi(s.giden_alici)}</td>
                            <td className="sayi">{sayi(s.gelen_ileti)}</td>
                          </tr>
                        ))}
                      </Tablo>
                    )}
                  </Kart>
                </div>
              </>
            )}
          </Durum>

          <p style={{ color: "var(--n-500)", fontSize: 12, marginTop: 20 }}>
            Kayıt tarihi: {tarih(d.veri.olusturma)}
          </p>
        </>
      )}
    </Durum>
  );
}

/**
 * Musteri bilgilerini duzenleme.
 *
 * Musteri olusturulabiliyordu ama adindaki bir yazim hatasi duzeltilemiyordu;
 * tek care veritabanina elle girmekti. Form yalnizca DEGISEN alanlari
 * gonderir — degismeyeni de gondermek denetim kaydini gereksiz kalabaliklastirir.
 */
function BilgiDuzenle({
  m,
  kaydedildi,
  hata,
}: {
  m: { ad: string; yetkili_ad: string | null; yetkili_eposta: string | null; telefon: string | null; id: string };
  kaydedildi: () => void;
  hata: (h: ApiHatasi) => void;
}) {
  const [acik, setAcik] = useState(false);
  const [ad, setAd] = useState(m.ad);
  const [yetkiliAd, setYetkiliAd] = useState(m.yetkili_ad ?? "");
  const [yetkiliEposta, setYetkiliEposta] = useState(m.yetkili_eposta ?? "");
  const [telefon, setTelefon] = useState(m.telefon ?? "");
  const [bekliyor, setBekliyor] = useState(false);

  const degisenler = () => {
    const g: Record<string, string> = {};
    if (ad.trim() && ad.trim() !== m.ad) g.ad = ad.trim();
    if (yetkiliAd.trim() !== (m.yetkili_ad ?? "")) g.yetkiliAd = yetkiliAd.trim();
    if (yetkiliEposta.trim() !== (m.yetkili_eposta ?? "")) g.yetkiliEposta = yetkiliEposta.trim();
    if (telefon.trim() !== (m.telefon ?? "")) g.telefon = telefon.trim();
    return g;
  };
  const g = degisenler();
  const degisti = Object.keys(g).length > 0;

  async function kaydet(e: React.FormEvent) {
    e.preventDefault();
    if (!degisti) return;
    setBekliyor(true);
    try {
      await api.musteriGuncelle(m.id, g);
      kaydedildi();
      setAcik(false);
    } catch (h) {
      hata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <Kart
      baslik="Müşteri bilgileri"
      eylem={
        <button className="dugme kucuk" onClick={() => setAcik((v) => !v)}>
          {acik ? "kapat" : "düzenle"}
        </button>
      }
    >
      <div className="ic">
        {!acik ? (
          <dl className="ikili">
            <dt>Ad</dt>
            <dd>{m.ad}</dd>
            <dt>Yetkili</dt>
            <dd>{m.yetkili_ad || "—"}</dd>
            <dt>E-posta</dt>
            <dd>{m.yetkili_eposta || "—"}</dd>
            <dt>Telefon</dt>
            <dd>{m.telefon || "—"}</dd>
          </dl>
        ) : (
          <form onSubmit={kaydet}>
            <label className="alan">
              <span>Müşteri adı</span>
              <input value={ad} onChange={(e) => setAd(e.target.value)} required />
              <small>Panelde ve posta sunucusunda aynı anda güncellenir.</small>
            </label>
            <label className="alan">
              <span>Yetkili kişi</span>
              <input value={yetkiliAd} onChange={(e) => setYetkiliAd(e.target.value)} />
            </label>
            <label className="alan">
              <span>Yetkili e-posta</span>
              <input
                type="email"
                value={yetkiliEposta}
                onChange={(e) => setYetkiliEposta(e.target.value)}
                autoComplete="email"
              />
              <small>Kota ve güvenlik bildirimleri bu adrese gider.</small>
            </label>
            <label className="alan">
              <span>Telefon</span>
              <input value={telefon} onChange={(e) => setTelefon(e.target.value)} inputMode="tel" />
            </label>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button className="dugme ana" disabled={!degisti || bekliyor}>
                {bekliyor ? "Kaydediliyor…" : degisti ? `Kaydet (${Object.keys(g).length} değişiklik)` : "Değişiklik yok"}
              </button>
              <button
                type="button"
                className="dugme"
                onClick={() => {
                  setAd(m.ad);
                  setYetkiliAd(m.yetkili_ad ?? "");
                  setYetkiliEposta(m.yetkili_eposta ?? "");
                  setTelefon(m.telefon ?? "");
                  setAcik(false);
                }}
              >
                Vazgeç
              </button>
            </div>
          </form>
        )}
      </div>
    </Kart>
  );
}
